import { Link } from "react-router-dom";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import { useLanguage } from "../i18n/LanguageContext";

export default function ExperienceItem({ experience, volunteer = false }) {
  const { t } = useLanguage();
  const {
    date,
    icon,
    jobTitle,
    companyName,
    link,
    description,
    moreLink,
    skills,
    descriptionList,
    roles,
  } = experience;
  return (
    <VerticalTimelineElement className="career-entry" icon={icon}>
      <div className="career-entry-meta">
        {date && <span>{date}</span>}
        <span
          className={
            volunteer ? "career-kind career-kind-volunteer" : "career-kind"
          }
        >
          {t(volunteer ? "career.volunteer" : "career.work")}
        </span>
      </div>
      {!roles && <h2 className="career-role">{jobTitle}</h2>}
      <p className="career-company">
        {link ? (
          <a href={link} target="_blank" rel="noreferrer">
            {companyName}
          </a>
        ) : (
          companyName
        )}
      </p>
      {skills && (
        <div className="career-technologies">
          {skills.map((skill) => (
            <span key={skill}>{skill}</span>
          ))}
        </div>
      )}
      {roles?.map((role) => (
        <section className="career-position" key={role.jobTitle}>
          <h2 className="career-role">{role.jobTitle}</h2>
          <p className="career-position-date">{role.date}</p>
          <details className="career-details">
            <summary>{t("career.roleDetails")}</summary>
            <p>{role.description}</p>
            <ul>
              {role.descriptionList.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </details>
        </section>
      ))}
      {(description || descriptionList) && (
        <details className="career-details">
          <summary>
            {t(volunteer ? "career.contributionDetails" : "career.roleDetails")}
          </summary>
          {description && <p>{description}</p>}
          {descriptionList && (
            <ul>
              {descriptionList.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </details>
      )}
      {moreLink && (
        <Link className="career-project-link" to={moreLink}>
          {t("career.projectLink")} <span aria-hidden="true">↗</span>
        </Link>
      )}
    </VerticalTimelineElement>
  );
}
